import { render, staticRenderFns } from "./AvatarPreview.vue?vue&type=template&id=49be8a80&"
import script from "./AvatarPreview.vue?vue&type=script&lang=js&"
export * from "./AvatarPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports